module.exports = __webpack_public_path__ + "img/Splash_ThreePhotoBottom.f07d36bf.jpg";